import { getOperatorLabel } from 'src/utils/lakehouse/flows'

export const ProductRowPolicies = ({ rowPolicies }: { rowPolicies: any[] }) => {
  const hasRules = rowPolicies.length > 0

  return (
    <>
      {!hasRules && (
        <div>
          <strong>Include</strong> all rows by default
        </div>
      )}

      {hasRules &&
        rowPolicies?.map((rowPolicy) => (
          <div key={rowPolicy.name}>
            <strong>{rowPolicy.name}</strong>
            {' is '}
            {getOperatorLabel(rowPolicy.operator!)?.toLowerCase()} {rowPolicy.value}
          </div>
        ))}
    </>
  )
}
